import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "./styles.css";
import "./dt-theme.css";
import { App } from "./App.jsx";
import { LocaleProvider } from "./i18n.jsx";

createRoot(document.getElementById("root")).render(<React.StrictMode><LocaleProvider><App /></LocaleProvider></React.StrictMode>);
